import { Capability, Role } from 'types/roles';

export const CAPABILITY_ROLES: Record<Capability, Role[]> = {
	[Capability.CREATE_PAYMENT]: [Role.CREATE, Role.CREATE_SIGN, Role.MANAGE],
	[Capability.SIGN_PAYMENT]: [Role.CREATE_SIGN, Role.SIGN, Role.MANAGE],
	[Capability.DELETE_PAYMENT]: [Role.CREATE, Role.CREATE_SIGN, Role.MANAGE],
	[Capability.MANAGE_TEMPLATE]: [Role.CREATE, Role.CREATE_SIGN, Role.MANAGE],
};
